import React from 'react'
import './BankCard.css'

const Bankdetails = () => {
  return (
    <div className="bank-page">
      <h1>Banks & Card</h1>
      <p>
        Securely add your preferred bank accounts, cards and crypto wallet. Your
        withdrawals would be processed into it.
      </p>
    </div>
  );
}

export default Bankdetails
